module.exports = {
          srcSet: __webpack_public_path__ + "65792b2b5db81340c660922b2ad2d87b-79.png"+" 79w",
          images:[ {path: __webpack_public_path__ + "65792b2b5db81340c660922b2ad2d87b-79.png",width: 79,height: 88}],
          src: __webpack_public_path__ + "65792b2b5db81340c660922b2ad2d87b-79.png",
          toString:function(){return __webpack_public_path__ + "65792b2b5db81340c660922b2ad2d87b-79.png"},
          
          width: 79,
          height: 88
        }